var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.curriculum)?_c('v-content',{staticClass:"fill-height white"},[_c('v-progress-linear',{attrs:{"indeterminate":""}})],1):_c('Curriculum',{attrs:{"curriculum":_vm.curriculum,"id":"print-curriculum"}})}
var staticRenderFns = []

export { render, staticRenderFns }